import axios from "axios"

export class Segments {
    static search(termo = null, limit = 10) {
        return axios.get(window.apis.segmentos, {
            params: { termo, limit },
        })
    }
}
